import { Injectable } from '@angular/core';
import { DeviceService } from './device.service';
import { DelegateType } from '../../shared/models/utility.model';
import { MobileWebViewService } from './mobile-web-view.service';
import { NotificationType } from '../../shared/models/login.model';
import { MobileDelegateService } from './mobile-delegate.service';
import { DeviceHelperService } from './device-helper.service';

@Injectable({
	providedIn: 'root',
})
export class MobileWebViewHelperService {
	readonly FIREBASE_KEY = 'mobile_web_view_device_firebase_key';

	constructor(
		private deviceService: DeviceService,
		private mobileService: MobileWebViewService,
		private delegateService: MobileDelegateService,
		private deviceHelper: DeviceHelperService
	) {}

	registerFirebaseToken(currentFireBaseToken = null): Promise<any> {
		return new Promise(async (resolve) => {
			try {
				// alert(`current Fire base Token from login res or sign up -> ${currentFireBaseToken}`);
				const newToken = await this.getFirebaseToken();
				// alert(`Fire base Token from App -> ${newToken}`);
				const isTokenChanged = currentFireBaseToken ? newToken !== currentFireBaseToken : true;
				// alert(`has Fire base Token changed -> ${isTokenChanged}`);
				const params = this.buildNotificationParams(newToken);
				const updateNotificationToken = isTokenChanged ? await this.updateNotificationTokenOfExistingDevice(params) : '';
				// alert(`updateNotificationToken response -> ${updateNotificationToken}`);
				const isFirebaseRegistered = isTokenChanged ? updateNotificationToken?.success : false;
				const isNotificationEnabled = isFirebaseRegistered ? await this.isNotificationEnabled() : false;
				const canRequestNotificationSetup = !isNotificationEnabled ? await this.canRequestNotificationSetup() : false;
				if (canRequestNotificationSetup) {
					await this.callRequestNotificationSetup();
					resolve({ success: true, error: null });
				} else {
					resolve({ success: true, error: null });
				}
			} catch (error) {
				// alert(`error ---> ${JSON.stringify(error)}`);
				resolve({ success: false, error: JSON.stringify(error) });
			}
		});
	}

	async callRequestNotificationSetup() {
		await this.requestNotificationSetup();
		await this.updateLoginCounter(0);
	}

	async getSavedFireBaseToken() {
		return this.delegateService.setDelegateData(DelegateType.getValue, this.FIREBASE_KEY);
	}

	async saveFireBaseToken(firebaseToken: string) {
		return this.delegateService.setDelegateData(DelegateType.saveValue, this.FIREBASE_KEY, firebaseToken);
	}

	async canRequestNotificationSetup() {
		let canRequestSetup: boolean;
		let loginCounter: number;
		const getLoginCounter = await this.getLoginCounter();
		loginCounter = getLoginCounter || 0;
		canRequestSetup = loginCounter >= 5;
		if (!canRequestSetup) {
			const newCounter = loginCounter++;
			await this.updateLoginCounter(newCounter);
		}
		return canRequestSetup;
	}

	getFirebaseToken() {
		return this.delegateService.getDelegateData(DelegateType.getFirebaseToken);
	}

	async setIsFirebaseRegistered(isRegister, firebaseToken) {
		await this.saveFireBaseToken(firebaseToken);
		return this.delegateService.setDelegateData(DelegateType.setIsFirebaseTokenRegistered, isRegister);
	}

	async isNotificationEnabled() {
		return this.delegateService.getDelegateData(DelegateType.isNotificationEnabled);
	}

	requestNotificationSetup() {
		return this.delegateService.getDelegateData(DelegateType.requestNotificationSetup);
	}

	updateLoginCounter(counter: number) {
		return this.delegateService.setDelegateData(DelegateType.updateLoginCounter, counter);
	}

	getLoginCounter() {
		return this.delegateService.getDelegateData(DelegateType.getLoginCounter);
	}

	async updateNotificationTokenOfExistingDevice(params) {
		// alert(`Updating Fire base token with params ---> ${JSON.stringify(params)}`);
		return this.deviceService.updateNotificationToken(params);
	}

	buildNotificationParams(notificationToken) {
		const deviceInformation = this.deviceHelper.getDeviceInformation();
		// alert(`deviceUniqueIdentifier ---> ${deviceInformation?.deviceUniqueIdentifier}`);
		return {
			deviceIdentifier: deviceInformation?.deviceUniqueIdentifier,
			notificationToken,
			deviceType: deviceInformation?.model?.toString()?.toUpperCase(),
			manufacturer: deviceInformation?.manufacturer,
			model: deviceInformation?.model,
			notificationTokenType: NotificationType.FIREBASE,
		};
	}
}
